import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useAuth from "../../hooks/useAuth";
import useResponsive from '../../hooks/useResponsive';
// components
import Iconify from '../../components/Iconify';
// util
import axios from '../../utils/axios';


export default function ScoutRequestDialog({ open, closeDialog }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");

  const handleError = (error) => {
    console.error(error);
    if (error.response && error.response.data && error.response.status === 400) {
      enqueueSnackbar(error.response.data.message, { variant: 'warning' });
    } else {
      enqueueSnackbar("요청이 실패하였습니다. 관리자에 문의해주세요.", { variant: 'warning' });
    }
  };

  const requestScout = async () => {
    setIsSubmit(true);
    const companyId = user?.employee.company[0].id;
    try {
      await axios.post(`/api/company/${companyId}/scout/request/`, { request: requestMessage });
      setIsSubmit(false);
      setSubmitted(true);
    } catch (error) {
      setIsSubmit(false);
      handleError(error);
    }
  };

  const stopPropagationForTab = (e) => {
    if (e.key === "Tab") {
      e.stopPropagation();
    }
  };

  useEffect(() => {
    if (open) {
      setSubmitted(false);
      setRequestMessage("");
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="sm" onKeyDown={stopPropagationForTab}>
      {/* contents */}
      {!submitted && (
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h5" sx={{ wordBreak: "keep-all" }} paragraph>
          다음에는 어떤 조건으로 찾아드릴까요?
        </Typography>
        <Typography paragraph>
          추천 조건을 변경하거나, 새로운 포지션을 요청하셔도 됩니다. 
        </Typography>
        <TextField
          value={requestMessage}
          onChange={(e) => setRequestMessage(e.target.value)}
          placeholder="예) 경력 8년차 이상만 추천받고 싶어요 / 프론트엔드 개발자도 추천해주세요 / A 크루는 결제 기능 개발 경험이 없어서 아쉬웠어요"
          multiline
          rows={8}
          fullWidth
          helperText={`${requestMessage.length} / 2000`}
          sx={{
            "& .MuiFormHelperText-root": {
              textAlign: "right",
            }
          }}
        />
      </DialogContent>
      )}
      {submitted && (
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant="h5" sx={{ wordBreak: "keep-all" }} paragraph>
          요청해주신 내용을 확인한 후 {!smUp && <br />}다음 추천에 반영하겠습니다.
        </Typography>
        <Typography sx={{ wordBreak: "keep-all" }}>
          문의 드릴 내용이 있으면 추가로 연락드리겠습니다.
        </Typography>
      </DialogContent>
      )}
      {/* buttons */}
      {!submitted && (
      <DialogActions sx={{ mx: { xs: 0, sm: 1 }, mb: { xs: 0, sm: 1 }, pt: "0!important" }}>
        <Stack
          display="flex"
          justifyContent="flex-end"
          direction={"row"}
          sx={{ width: 1 }}
          spacing={1}
        >
          <LoadingButton
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
            loading={isSubmit}
          >
            취소
          </LoadingButton>
          <LoadingButton
            variant="contained"
            onClick={requestScout}
            size="large"
            sx={{ px: 4 }}
            loading={isSubmit}
            disabled={!requestMessage || requestMessage.length > 2000}
          >
            요청하기
          </LoadingButton>
        </Stack>
      </DialogActions>
      )}
      {submitted && (
      <DialogActions sx={{ mx: { xs: 0, sm: 1 }, mb: { xs: 0, sm: 1 }}}>
        <Stack
          display="flex"
          justifyContent="flex-end"
          direction={"row"}
          sx={{ width: 1 }}
        >
          <LoadingButton
            variant="contained"
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
            loading={isSubmit}
            fullWidth={!smUp}
          >
            확인했어요
          </LoadingButton>
        </Stack>
      </DialogActions>
      )}
    </Dialog>
  )
}
